var _circle, _circle2, _circle3, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaleIconGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#16C1F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gender_icon_round_mask",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#5985CF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "url(#paint0_radial)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#gender_icon_round_mask)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "#36A9E1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4196 30.2904C28.3134 31.4287 27.0473 32.2823 24.6142 33.5628C22.5096 34.6704 19.8834 35.0223 17.5037 35.0223C15.1241 35.0223 12.3784 34.4809 10.2442 33.4205C7.9534 32.2823 6.97189 31.7132 5.58789 30.2904C6.03311 29.2598 6.77065 26.5482 7.9534 25.8631C9.03901 25.2362 10.5572 24.8165 12.2392 24.5553C13.9213 24.294 15.763 24.187 17.5008 24.187C20.9756 24.187 24.8744 24.6084 27.0473 25.8631C28.2368 26.5482 28.971 29.2598 29.4196 30.2904Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4196 30.2904C28.3134 31.4287 27.0473 32.2823 24.6142 33.5628C22.5096 34.6704 19.8834 35.0223 17.5037 35.0223C15.1241 35.0223 12.3784 34.4809 10.2442 33.4205C7.9534 32.2823 6.97189 31.7132 5.58789 30.2904C6.03311 29.2598 6.77065 26.5482 7.9534 25.8631C9.03901 25.2362 10.5572 24.8165 12.2392 24.5553C13.9213 24.294 15.763 24.187 17.5008 24.187C20.9756 24.187 24.8744 24.6084 27.0473 25.8631C28.2368 26.5482 28.971 29.2598 29.4196 30.2904Z",
    fill: "#243443"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9711 24.4071V21.0599H14.03V24.4071C12.9765 24.5857 12.2432 24.9447 12.2432 25.6989C12.2432 27.1711 14.242 28.7014 17.4997 28.7014C20.879 28.7014 22.757 27.1711 22.757 25.6989C22.757 24.9447 22.0237 24.5857 20.9711 24.4071Z",
    fill: "#FBCBAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2643 16.9645C13.2643 15.9238 12.8073 14.6581 12.2438 14.6581C11.6803 14.6581 11.1016 14.8586 11.1016 15.8985C11.1016 16.4041 11.2798 17.5215 11.453 18.0128C11.6389 18.5429 11.9515 18.8471 12.2438 18.8471C12.8073 18.8471 13.2643 18.0044 13.2643 16.9645Z",
    fill: "#FBCBAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7354 16.9645C21.7354 15.9238 22.1924 14.6581 22.7559 14.6581C23.3194 14.6581 23.8981 14.8586 23.8981 15.8985C23.8981 16.4041 23.7198 17.5215 23.5467 18.0128C23.3608 18.5429 23.0482 18.8471 22.7559 18.8471C22.1924 18.8471 21.7354 18.0044 21.7354 16.9645Z",
    fill: "#F2B99A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9714 21.8428V23.6184C20.8264 23.7453 20.6747 23.8643 20.5168 23.9748C19.9119 24.3962 19.4862 24.6726 19.0891 24.8386C18.6933 25.0025 18.2671 25.0803 17.8387 25.0669C16.8663 25.0669 16.3687 24.8234 15.1615 23.9715C14.7359 23.6728 14.355 23.3153 14.0303 22.9097V21.8437C14.2719 22.0931 14.537 22.3189 14.8219 22.5178C16.0308 23.3681 16.5284 23.6133 17.5008 23.6133C17.9293 23.6269 18.3558 23.5493 18.752 23.3858C19.1482 23.2172 19.574 22.9451 20.1789 22.5204C20.4646 22.3208 20.73 22.0939 20.9714 21.8428Z",
    fill: "#DB9172",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5009 8.26294C13.3233 8.26294 12.1836 11.8536 12.1836 16.2836C12.1836 19.222 13.1045 21.3144 14.822 22.5195C16.0309 23.3689 16.5285 23.6149 17.5009 23.6149C18.4725 23.6149 18.9701 23.3722 20.179 22.5195C21.8966 21.3119 22.8174 19.2195 22.8174 16.2836C22.8174 11.8536 21.6778 8.26294 17.5009 8.26294Z",
    fill: "#FBCBAB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4989 8.26294C17.4271 8.26294 17.3578 8.26294 17.2877 8.26884C20.9838 8.39019 22.0027 11.9303 22.0027 16.2836C22.0027 19.222 21.1519 21.3144 19.5662 22.5194C18.5338 23.3048 18.0624 23.5711 17.2852 23.6074C17.3536 23.6074 17.4237 23.6074 17.4964 23.6074C18.4688 23.6074 18.9664 23.3647 20.1753 22.5119C21.8928 21.3043 22.8137 19.2119 22.8137 16.276C22.8162 11.8536 21.6766 8.26294 17.4989 8.26294Z",
    fill: "#ECA182",
    fillOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1467 10.3418C24.0436 9.50927 23.4007 7.46324 22.4384 7.33262C22.0008 7.27363 21.7262 7.5197 21.3942 7.36549C21.1222 7.23993 19.9512 5.80484 18.9442 5.30344C17.726 4.69587 15.9434 4.32172 14.7344 4.71356C13.2501 5.19473 13.3092 6.40988 12.7423 6.87842C12.1755 7.34695 11.1997 7.88964 11.1186 8.58653C10.9952 9.64495 11.5148 10.4826 11.476 11.482C11.4455 12.2876 10.9691 13.0603 11.1659 13.8769C11.2698 14.31 11.8046 14.6252 11.8849 15.0693C11.9305 15.3221 11.9938 15.944 12.1814 16.1513C12.5835 16.5988 12.5852 13.737 12.679 12.8834C12.7567 12.1654 12.9831 11.3615 13.3971 10.7505C13.9293 9.96348 14.7834 10.0562 15.6198 10.2382C16.4697 10.4219 17.2639 10.593 18.1467 10.491C19.0295 10.389 19.9648 9.99297 20.8248 10.4067C21.6325 10.7944 22.1022 11.6708 22.2939 12.5059C22.3903 12.923 22.3083 15.7544 22.7544 15.9423C22.9892 16.0409 23.072 15.1072 23.5147 14.7912C23.8957 14.5199 24.0081 14.1946 24.0934 13.7446C24.308 12.6365 24.2844 11.4525 24.1467 10.3418Z",
    fill: "#243443"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7566 15.9389C22.3114 15.751 22.3925 12.9196 22.297 12.5025C22.1052 11.6674 21.6347 10.791 20.827 10.4042C19.967 9.99128 19.0309 10.3857 18.1489 10.4885C17.2669 10.5913 16.4711 10.4211 15.622 10.2357C14.773 10.0503 13.9324 9.96095 13.3985 10.7472C12.9853 11.359 12.7589 12.1629 12.6812 12.8817C12.5967 13.673 12.5857 16.196 12.2588 16.196C12.6026 16.2339 12.742 14.16 12.8291 13.4598C12.9076 12.8278 13.058 11.7744 13.477 11.2385C14.2754 10.2138 15.132 10.4876 15.9346 10.7741C16.8234 11.0901 17.2619 11.2587 18.1447 11.1677C19.0275 11.0767 19.9628 10.7303 20.8228 11.0935C21.6305 11.4348 22.15 12.1148 22.259 13.0443C22.3038 13.4218 22.3038 15.8033 22.749 15.9684C22.7735 15.9777 22.7904 15.9684 22.8005 15.9423C22.7858 15.9451 22.7707 15.9439 22.7566 15.9389ZM12.1523 16.1075C12.1596 16.1246 12.1702 16.1401 12.1836 16.153C12.1927 16.1627 12.2033 16.1709 12.2149 16.1774C12.2034 16.1684 12.1929 16.1583 12.1836 16.1471C12.1725 16.1356 12.162 16.1235 12.1523 16.1108V16.1075Z",
    fill: "#DB9172",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5 5.71008) rotate(90) scale(29.2899)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#901B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5221C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIconGeneric);
export default __webpack_public_path__ + "static/media/maleIconGeneric.ecf8ec0000a2de1451636d94181bec7d.svg";
export { ForwardRef as ReactComponent };